export const RELATED_TO_ROUTE_MAP = {
  "nets_taxes.Declaration": "/:customerName/taxes/declaration/:id",
  "nets_taxes.DeclarationAdjustment": "/:customerName/taxes/declaration/:id",
  "nets_taxes.RetentionStatement": "/:customerName/taxes/retention/:id",
  "nets_motor.VehicleStatement": "/:customerName/motor/vehicle/:id",
  "nets_cadastre.CadastralStatement":
    "/:customerName/cadaster/realestate/detail/:id",
  "nets_cadastre.RealEstate": "/:customerName/cadaster/realestate/detail/:id",
  "nets_motor.Inscription": "/:customerName/motor/vehicle/:id",
  "nets_service.ServiceInvoice": "/:customerName/service/invoice/:id",
  "shopping_cart.UserProduct": "/:customerName/accounts/userProduct/:id",
  "shopping_cart.AccountingAdjustment":
    "/:customerName/accounts/adjustment/:id",
  "nets_corporate.UserProcedure": "/:customerName/corporate/procedure/:id",
  "nets_eventads.AdRequest": "/:customerName/eventads/request/:id",
  "nets_stamp.StampOrder": "/:customerName/stamp/order/:id",
  "nets_taxes.Penalty": "/:customerName/taxes/penalty/detail/:id",
  "nets_socialresp.SocialResponsibility":
    "/:customerName/socialresp/detail/:id",
  "nets_urbin.UrbanRequest": "/:customerName/urbin/request/detail/:id",
  "nets_taxes.InformalPermissionStatement":
    "/:customerName/infeco/permission/statement/:id",
  "shopping_cart.PaymentAgreement":
    "/:customerName/accounts/paymentAgreement/detail/:id",
  "shopping_cart.PaymentAgreementQuote":
    "/:customerName/accounts/paymentAgreementQuote/detail/:id",
  "nets_taxes.TaxAmendment": "/:customerName/taxes/taxAmendment/detail/:id",
  "nets_police.PoliceFine": "/:customerName/police/fines/:id",
  "nets_environment.WasteTransportation":
    "/:customerName/environment/waste/transportation/:id",
  "nets_user.IdentityMember": "/app/account/selectIdentity/",
  "nets_support.Ticket": "/:customerName/support/ticket/detail/:id",
  "nets_support.ticket.assigned": "/:customerName/support/ticket/detail/:id",
  "nets_approval.ApprovalRequest": "/:customerName/approval/detail/:id",
};

export const parseRelatedTo = (relatedTo) => {
  if (!relatedTo || typeof relatedTo !== "string") {
    return null;
  }

  const parts = relatedTo.split(":");
  if (parts.length < 2) {
    return null;
  }

  const model = parts[0];
  const id = parts[1];

  if (!model || !id) {
    return null;
  }

  return { model, id };
};

export const resolveRelatedToPath = ({ relatedTo, customerShortname }) => {
  const parsed = parseRelatedTo(relatedTo);

  if (!parsed || !customerShortname) {
    return null;
  }

  const template = RELATED_TO_ROUTE_MAP[parsed.model];
  if (!template) {
    return null;
  }

  return template
    .replace(":customerName", customerShortname)
    .replace(":id", parsed.id);
};
